module.exports = __webpack_public_path__ + "static/img/dy.27b5d1a6.png";